import { render, staticRenderFns } from "./StaffProducts.vue?vue&type=template&id=a456776e&scoped=true"
import script from "./StaffProducts.vue?vue&type=script&lang=js"
export * from "./StaffProducts.vue?vue&type=script&lang=js"
import style0 from "./StaffProducts.vue?vue&type=style&index=0&id=a456776e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a456776e",
  null
  
)

export default component.exports